import axios, { AxiosResponse } from 'axios';
import AuthProfileDTO from 'src/models/generated/AuthProfileDTO';
import CaseDetailDTO from 'src/models/generated/CaseDetailDTO';
import CRMLookupDTO from 'src/models/generated/CRMLookupDTO';
import UserProfileDTO from 'src/models/generated/UserProfileDTO';
import { AxiosUtil } from 'src/utils';
import { APILookupFormFormData, RequestTypeType } from '../components/APILookupForm';
import APILookupDTO from '../models/generated/APILookupDTO';

class AccountController {
    private prefix: string = "crmlookup";

    /** Not exactly a login in the traditional sense */
    doLogin(password: string) {
        let route = `${this.prefix}?password=${password}`;
        return AxiosUtil.get<AuthProfileDTO>(route, AuthProfileDTO.create);
    }

    getAccountDetails(accountNumber: string) {
        let route = `${this.prefix}/accounts/${accountNumber}`;
        return AxiosUtil.get<CRMLookupDTO>(route, CRMLookupDTO.create);
    }

    getCaseDetails(accountNumber: string, caseNumber: string) {
        let route = `${this.prefix}/accounts/${accountNumber}/cases/${caseNumber}`;
        return AxiosUtil.get<CaseDetailDTO>(route, CaseDetailDTO.create);
    }
    getTypesForLocationData(view: RequestTypeType) {
        const map = {
            'Summary': '',
            'Transactions': 'Transaction',
            'Groups': 'Group'
        };  
        const reqView = map[view] || 'invalid';
        let route = `locationdata/views/${reqView}/types`;
        return AxiosUtil.get<string[]>(route);
    }
    getTableDataForView(values: APILookupFormFormData) {  
        const map = {
            'Summary': 'Summary',
            'Transactions': 'Transaction',
            'Groups': 'Group'
        };
        const reqView = map[values.requestType] || 'invalid';
        let uri = `locationdata/views/${reqView}?licensenumber=${values.license}`;
        if (values.type && values.type.trim().length)
            uri += `&type=${values.type}`;
        if (values.dateRange) {
            if (values.dateRange[0])
                uri += `&beginDate=${values.dateRange[0].format()}`;
            if (values.dateRange[1])
                uri += `&endDate=${values.dateRange[1].format()}`;
        }
        return AxiosUtil.get<APILookupDTO>(uri, APILookupDTO.create);
    }
}

export default new AccountController();
